import React, { Dispatch, SetStateAction, useContext } from 'react'
import { Button } from '../../../../components/common/Button'
import { Input } from '../../../../components/common/Input'
import {
  FormRadioContainer,
  InputContainer,
  RadioAppearence,
  RadioContainer,
  RadioInput,
  SubmitContainer,
  Text,
} from './styles'

import { Context } from '../../../../context/context_recoverPassword'
import api from '../../../../services/api'

interface RecoverPasswordFirstStepProps {
  openModal: Dispatch<SetStateAction<boolean>>
}

export const RecoverPasswordFirstStep = ({
  openModal,
}: RecoverPasswordFirstStepProps) => {
  // const [recoverPasswordOption, setRecoverPasswordOption] = useState('')
  // const [smsInput, setSmsInput] = useState('')
  // const [emailInput, setEmailInput] = useState('')

  const { recoverPasswordInfos, setRecoverPasswordInfos } = useContext(Context)

  const handleRadioChange = (newCanalType) => {
    setRecoverPasswordInfos((prev) => ({ ...prev, canalType: newCanalType }))
  }

  const setEmailInput = (newEmail) => {
    setRecoverPasswordInfos((prev) => ({ ...prev, email: newEmail }))
  }

  const setSmsInput = (newSMS) => {
    setRecoverPasswordInfos((prev) => ({ ...prev, sms: newSMS }))
  }

  const toggleFunction = (setValue) => {
    setValue((prev) => !prev)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (recoverPasswordInfos.canalType === 'sms') {
      const smsFormatted = recoverPasswordInfos.sms
        .replace(/[()]/g, '')
        .replace(/\s/g, '')

      api
        .post('/v1/user/password/recover/sms', {
          phone: '55' + smsFormatted,
        })
        .then((response) => {
          console.log(response)
          toggleFunction(openModal)
        })
        .catch((error) => {
          console.log(error.response)
        })
    } else {
      api
        .post('/v1/user/password/recover/email', {
          email: recoverPasswordInfos.email,
        })
        .then((response) => {
          console.log(response)
          toggleFunction(openModal)
        })
        .catch((error) => {
          console.log(error.response)
        })
    }
  }

  return (
    <InputContainer>
      <Text>
        Para prosseguir, iremos enviar um código para confirmarmos seu acesso.
        Selecione uma das opções de envio:
      </Text>
      <RadioContainer>
        <FormRadioContainer>
          <RadioInput
            name="recoverPasswordOption"
            id="email"
            onClick={() => handleRadioChange('email')}
          />
          <RadioAppearence
            htmlFor="email"
            isChecked={recoverPasswordInfos.canalType === 'email'}
          >
            E-Mail
          </RadioAppearence>
          <RadioInput
            id="sms"
            name="recoverPasswordOption"
            onClick={() => handleRadioChange('sms')}
          />
          <RadioAppearence
            htmlFor="sms"
            isChecked={recoverPasswordInfos.canalType === 'sms'}
          >
            SMS
          </RadioAppearence>
        </FormRadioContainer>
      </RadioContainer>
      {recoverPasswordInfos.canalType === 'email' ? (
        <>
          <Text>Digite o e-mail para receber o código de acesso:</Text>
          <Input.Root>
            <Input.Label
              title="E-mail"
              htmlFor="recoverPasswordFormEmail"
              color="#150D49"
            />
            <Input.Wrapper
              borderColor="#0079B1"
              backgroundColor="#EDF4FC"
              outlineColor="#006598"
            >
              <Input.Content
                id="recoverPasswordFormEmail"
                placeholder="E-mail"
                type="email"
                value={recoverPasswordInfos.email}
                onChange={(e) => setEmailInput(e.target.value)}
                required
              />
            </Input.Wrapper>
          </Input.Root>
        </>
      ) : recoverPasswordInfos.canalType === 'sms' ? (
        <>
          <Text>Digite o telefone para receber o código de acesso:</Text>
          <Input.Root>
            <Input.Label
              title="Telefone"
              htmlFor="contactFormNumber"
              color="#150D49"
            />
            <Input.Wrapper
              borderColor="#0079B1"
              backgroundColor="#EDF4FC"
              outlineColor="#006598"
            >
              <Input.Content
                type="tel"
                id="contactFormNumber"
                placeholder="(xx) xxxx-xxxx"
                mask="telNumber"
                pattern="(\(\d{2}\)\s?\d{5}-\d{4})"
                value={recoverPasswordInfos.sms}
                onChange={(e) => setSmsInput(e.target.value)}
                required
              />
            </Input.Wrapper>
          </Input.Root>
        </>
      ) : null}
      <SubmitContainer>
        <Button.Root
          type="submit"
          backgroundColor="#150D49"
          onClick={(e) => {
            handleSubmit(e)
          }}
          disabled={recoverPasswordInfos.canalType === ''}
        >
          <Button.Content title="Enviar recuperação de senha" />
        </Button.Root>
      </SubmitContainer>
    </InputContainer>
  )
}
